// Suggestion chips per curriculum, paired by position so switching region swaps each
// chip for its counterpart. 49 of the first 173 custom prompts were a chip used as-is.
const promptSuggestions = {
  UK: [
    "Create 10 Year 7 algebra questions on simplifying expressions.",
    "Generate a Year 5 fractions worksheet with mixed difficulty.",
    "Create 15 geometry questions involving area and perimeter.",
    "Generate beginner probability questions for Year 6.",
    "Create a worksheet on solving two-step equations with answers.",
    "Create 20 increasingly difficult percentage questions starting from easy mental maths.",
    "Generate differentiated questions for low, medium and high ability students on ratio.",
    "Create challenge-style algebra questions for able Year 9 students.",
    "Generate simple scaffolded fractions questions for students who find them hard.",
    "Create GCSE-style problem-solving questions for Year 11.",
    "Create 6 Year 6 area and perimeter questions, each with a labelled rectangle diagram in centimetres.",
    "Create 6 Year 7 triangle area questions, each with a diagram showing the base and perpendicular height.",
    "Create 6 Year 7 questions showing simple inequalities on blank number-line diagrams.",
    "Create 6 Year 6 questions reading marked values on number-line diagrams, including negative numbers.",
    "Create 8 Year 5 questions classifying acute, right, obtuse and reflex angles, each with an angle diagram.",
    "Create 6 Year 7 coordinate-plotting questions in all four quadrants, each with a blank coordinate grid.",
  ],
  US: [
    "Create 10 7th grade algebra questions on simplifying expressions.",
    "Generate a 5th grade fractions worksheet with mixed difficulty.",
    "Create 15 geometry questions involving area and perimeter.",
    "Generate beginner probability questions for 6th grade.",
    "Create a worksheet on solving two-step equations with answers.",
    "Create 20 increasingly difficult percent questions starting from easy mental math.",
    "Generate differentiated questions for below-level, on-level and advanced students on ratios.",
    "Create challenge-style algebra questions for advanced 8th graders.",
    "Generate simple scaffolded fractions questions for students who find them hard.",
    "Create SAT-style reasoning questions for 11th grade.",
    "Create 6 5th grade area and perimeter questions, each with a labeled rectangle diagram in centimeters.",
    "Create 6 6th grade triangle area questions, each with a diagram showing the base and perpendicular height.",
    "Create 6 6th grade questions showing simple inequalities on blank number-line diagrams.",
    "Create 6 6th grade questions reading marked values on number-line diagrams, including negative numbers.",
    "Create 8 4th grade questions classifying acute, right, obtuse and reflex angles, each with an angle diagram.",
    "Create 6 6th grade coordinate-plotting questions in all four quadrants, each with a blank coordinate grid.",
  ],
};

export default promptSuggestions;
